import type { PublicAppSettings } from '@innermate/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from './api.js';

/**
 * GET /api/app/settings 캐시. 관리자 토글 변경 후 30 초 안에 자동 반영.
 * 즉시 반영이 필요하면 useQueryClient().invalidateQueries({queryKey:['app','settings']}).
 */
export function useAppSettings() {
  return useQuery<PublicAppSettings>({
    queryKey: ['app', 'settings'],
    queryFn: () => api.appSettings(),
    staleTime: 30_000,
  });
}
